module.exports = "/static/assets/42bede21a59051341e756d2ae3f64723.svg";